/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { GridGuideRow } from '../entities/GridGuideRow';
import { GridGuideRepositoryImpl } from '../impls/GridGuideServiceRepositoryImpl';
import { IGridGuideServiceRepository } from '../interfaces/IGridGuideServiceRepository';
import { TServicesParams } from '../types/TServicesParams';

export class GridGuideService implements IGridGuideServiceRepository {
    private oGridGuideServiceRepository: IGridGuideServiceRepository;

    constructor(params: TServicesParams) {
        this.oGridGuideServiceRepository = new GridGuideRepositoryImpl(params);
    }

    async fetchProgramMetadata(
        stationId: string[],
        startTime: Date,
        endTime: Date,
    ): Promise<GridGuideRow[]> {
        return this.oGridGuideServiceRepository.fetchProgramMetadata(stationId, startTime, endTime);
    }
}
